/**
 * 公車路線辨識色（與 backend/utils/bus-route-colors.js 邏輯一致）
 */
const BUS_ROUTE_PALETTE = [
    '#E6194B', '#3CB44B', '#4363D8', '#F58231', '#911EB4',
    '#42D4F4', '#F032E6', '#BFEF45', '#469990', '#9A6324',
    '#800000', '#000075', '#FFD700', '#DCBEFF', '#FF7F50',
    '#6495ED', '#C71585', '#20B2AA', '#FF6347', '#7B68EE',
    '#00CED1', '#B22222', '#228B22', '#DAA520', '#6A5ACD',
    '#2E8B57', '#CD5C5C', '#1E90FF', '#FF69B4', '#008B8B',
    '#8B4513', '#5F9EA0'
];

export function hashRouteKey(key) {
    let h = 0;
    const s = String(key);
    for (let i = 0; i < s.length; i++) {
        h = ((h << 5) - h + s.charCodeAt(i)) | 0;
    }
    return Math.abs(h);
}

export function routeColorKey(props = {}) {
    return props.ref || props.route_id || props.name || props.id || '';
}

export function resolveBusRouteColor(props = {}) {
    const existing = props.color;
    if (existing && /^#[0-9A-Fa-f]{6}$/i.test(String(existing).trim())) {
        return String(existing).trim();
    }
    const key = routeColorKey(props);
    if (!key) return '#6B7280';
    return BUS_ROUTE_PALETTE[hashRouteKey(key) % BUS_ROUTE_PALETTE.length];
}

/** 公車站牌彈窗深色底（與 bus-stop-popup.css 一致） */
export const BUS_POPUP_SURFACE = '#1e293b';

function parseHex(hex) {
    const s = String(hex).trim().replace(/^#/, '');
    if (!/^[0-9A-Fa-f]{6}$/i.test(s)) return { r: 107, g: 114, b: 128 };
    return {
        r: parseInt(s.slice(0, 2), 16),
        g: parseInt(s.slice(2, 4), 16),
        b: parseInt(s.slice(4, 6), 16)
    };
}

function rgbToHex({ r, g, b }) {
    const clamp = (n) => Math.max(0, Math.min(255, Math.round(n)));
    return `#${[r, g, b].map((n) => clamp(n).toString(16).padStart(2, '0')).join('')}`;
}

/** 將 accent 以 fgRatio 疊在 surface 上（對應 CSS color-mix 百分比） */
export function mixHexColors(fgHex, bgHex, fgRatio) {
    const fg = parseHex(fgHex);
    const bg = parseHex(bgHex);
    const t = Math.max(0, Math.min(1, Number(fgRatio) || 0));
    return rgbToHex({
        r: fg.r * t + bg.r * (1 - t),
        g: fg.g * t + bg.g * (1 - t),
        b: fg.b * t + bg.b * (1 - t)
    });
}

export function relativeLuminance(hex) {
    const { r, g, b } = parseHex(hex);
    const lin = [r, g, b].map((c) => {
        c /= 255;
        return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
    });
    return 0.2126 * lin[0] + 0.7152 * lin[1] + 0.0722 * lin[2];
}

/**
 * 依 pill 實際背景亮度選深／淺字色（深色彈窗上避免 #000075 等路線色當文字）
 * @param {number} accentMix - 與 CSS color-mix 中 accent 占比一致（chip 18%、badge 22%）
 */
export function contrastTextOnMixedSurface(
    accentHex,
    surfaceHex = BUS_POPUP_SURFACE,
    accentMix = 0.18
) {
    const effectiveBg = mixHexColors(accentHex, surfaceHex, accentMix);
    return relativeLuminance(effectiveBg) > 0.4 ? '#0f172a' : '#f8fafc';
}

export function chipStyleVars(accentHex, accentMix = 0.18) {
    const text = contrastTextOnMixedSurface(accentHex, BUS_POPUP_SURFACE, accentMix);
    return `--chip-color:${accentHex};--chip-text-color:${text}`;
}

export function badgeStyleVars(accentHex, accentMix = 0.22) {
    const text = contrastTextOnMixedSurface(accentHex, BUS_POPUP_SURFACE, accentMix);
    return `--badge-color:${accentHex};--badge-text-color:${text}`;
}
